import { render } from "./discount-code.vue?vue&type=template&id=52ce3aae"
import script from "./discount-code.vue?vue&type=script&lang=js"
export * from "./discount-code.vue?vue&type=script&lang=js"

import "./discount-code.vue?vue&type=style&index=0&id=52ce3aae&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__